import { useCallback } from 'react';
import useApi from './useApi';
import { ChangeSetBM } from '../types/ChangeSetTypes';
import { useAppSettings } from '../hooks/useAppSettings';
import { mapChangeSetBM } from '../factory/ChangeSetFactory';

export default () => {
    const { state, getApiData } = useApi();
    const { settings: appSettings } = useAppSettings();

    const getChangeSet = useCallback(
        async (id: number) => {
            try {
                const apiUrl = appSettings?.api;
                if (!apiUrl) {
                    throw new Error('API URL not configured in app settings');
                }

                const fullUrl = `${apiUrl}GetChangeSet?id=${id}`;
                console.log('[useGetChangeSet] Calling:', fullUrl);
                await getApiData({
                    endpoint: fullUrl,
                });
            } catch (error) {
                console.error('[useGetChangeSet] Failed to fetch change set:', error);
            }
        },
        [getApiData, appSettings]
    );

    // Transform the API response to view model
    const getTransformedChangeSet = () => {
        if (state.status === 'success' && state.result) {
            const changeSetBM = state.result as ChangeSetBM;
            return mapChangeSetBM(changeSetBM);
        }
        return null;
    };

    return {
        changeSet: getTransformedChangeSet(),
        loading: state.isLoading,
        error: state.error,
        getChangeSet,
        status: state.status,
    };
};
